<template>
  <div id="app">

    <div id="body_bg">

      <div id="site_bg">

        <div id="site_bg_2">

          <div id="site">

            <div id="nonFooter">


              <!-- HEADER -->

              <div id="header">

                <div id="header_box">

                  <div class="illustration">

                    <div id="logozone">

                      <h2 id="logo">
                        <router-link to="/"><span>Salon Jája</span></router-link>
                      </h2>

                      <p id="moto">
                        <span id="rbcCompanySlogan" class="rbcNoStyleSpan"></span>
                      </p>

                    </div>

                    <img src="../static/img/logo.jpg" width="770" height="266" />

                  </div>

                </div>

              </div>

              <!-- /HEADER -->


              <div class="cleaner">
                <!-- / -->
              </div>


              <!-- MENU -->

              <app-menu></app-menu>

              <div class="cleaner">
                <!-- / -->
              </div>

              <!-- /MENU -->


              <!-- MAIN -->

              <div id="main">

                <div id="content">

                  <!-- CONTENT -->

                  <router-view></router-view>

                  <!-- /CONTENT -->

                </div>


                <!-- SIDEBAR -->

                <app-sidebar></app-sidebar>

                <!-- /SIDEBAR -->

                <hr class="cleaner" />

              </div>

              <!-- /MAIN -->


              <div class="cleaner">
                <!-- / -->
              </div>

            </div>


            <!-- FOOTER -->

            <div id="footer" style="display: none"></div>

            <!-- FOOTER -->

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import AppMenu from './components/fragments/AppMenu'
  import AppSidebar from './components/fragments/AppSidebar'

  export default {
    name: 'app',
    components: {
      AppMenu, AppSidebar
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?a6ccc3fa